import { useDispatch, useSelector } from 'react-redux';
import { selectFeatureFlags } from '@noths/polaris-client-user-configuration';

import { trackOpenContactPartnerModal } from 'src/components/molecules/ContactPartnerModal/tracking/contactPartnerModalEvents';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { actions } from 'src/redux/contactPartner';
import { getOptionsCostRange } from 'src/redux/product/utils/getOptionsCostRange';
import {
  selectAccessibility,
  selectBasket,
  selectProduct,
  selectSuspended,
} from 'src/redux/selectors';
import { getPartnerHref } from 'src/utils/getPartnerHref';

export const useStandardLayout = () => {
  const dispatch = useDispatch();
  const state = useSelector((state: ReduxApplicationState) => state);
  const accessibility = selectAccessibility(state);
  const basket = selectBasket(state);
  const product = selectProduct(state);
  const featureFlags = selectFeatureFlags(state);
  const suspended = selectSuspended(state);
  const partnerName = product.partner.name;

  const openContactPartnerModal = () => {
    dispatch(actions.openContactPartnerModal());
    trackOpenContactPartnerModal(partnerName);
  };

  return {
    optionsCostRange: getOptionsCostRange(product.options, product.price.currency),
    pageLiveRegionText: accessibility.statusMessage,
    product,
    partnerHref: getPartnerHref(product.partner.shortcode, featureFlags || {}),
    basketMutationError: Boolean(basket.error),
    suspended,
    openContactPartnerModal,
  };
};
